// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2Kr7E","footer":"ModalCreateQualiphyProcedure_footer__52pvq","additionData":"ModalCreateQualiphyProcedure_additionData__3qE_p"};